import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { ImageLabel } from './types';
import { Caption } from '@material-bank/mb3-components';
import { LeafIcon } from '@material-bank/mtag-icons';
type Label = {
  icon: ReactNode;
  content: string;
  bgColor: string;
  color: string;
};
type GalleryImageLabelProps = {
  labelType?: ImageLabel | null;
  labelContent?: string;
};
const LABEL_MAP: Record<ImageLabel, Label> = {
  sustainability: {
    icon: <LeafIcon fill="none" width={12} height={12} />,
    content: 'Sustainable',
    bgColor: 'bg-brand-dark',
    color: 'text-black'
  },
  title: {
    icon: null,
    content: 'Title',
    bgColor: 'bg-black/40',
    color: 'text-white'
  }
};
export function GalleryImageLabel(t0) {
  const $ = _c(7);
  const {
    labelType,
    labelContent
  } = t0;
  if (!labelType) {
    return null;
  }
  const label = LABEL_MAP[labelType];
  const t1 = `flex flex-wrap items-center gap-1 rounded-md px-3 py-1 text-sm font-semibold ${label.bgColor} w-full max-w-full break-words whitespace-normal`;
  const t2 = `${label.color} block max-w-full`;
  const t3 = labelContent ? labelContent : label.content;
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = <Caption weight="semibold" className={t2}>{t3}</Caption>;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== label.icon || $[4] !== t1 || $[5] !== t4) {
    t5 = <div className="absolute inset-x-3 top-3 z-10"><span className={t1}>{label.icon}{t4}</span></div>;
    $[3] = label.icon;
    $[4] = t1;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}